/* ============================================================
   HOFA — Product Page Popup ONLY
   Collection page popup is handled by main-collection.liquid
   
   Install:
   Assets → "hofa-product-popup.js" → paste → Save
   theme.liquid before </body>:
   <script src="{{ 'hofa-product-popup.js' | asset_url }}" defer></script>
   ============================================================ */
(function () {
  'use strict';

  /* Only run on product pages */
  if (!window.location.pathname.includes('/products/')) return;

  var C = { bg: '#EFE8DC', dark: '#17172A', gold: '#B8934A', pink: '#C26B84', border: '#D9CFC3', card: '#F5F0E8' };

  /* ── CSS ── */
  function injectCSS() {
    if (document.getElementById('hofa-pp-css')) return;
    var s = document.createElement('style');
    s.id = 'hofa-pp-css';
    s.textContent = `
      @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,900;1,400&family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&display=swap');

      #hofa-pp-overlay {
        position: fixed; inset: 0; z-index: 99999;
        background: rgba(23,23,42,0.6);
        display: flex; align-items: center; justify-content: center;
        padding: 20px;
        opacity: 0; visibility: hidden;
        transition: opacity 0.28s, visibility 0.28s;
        backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px);
      }
      #hofa-pp-overlay.is-open { opacity: 1; visibility: visible; }

      #hofa-pp-box {
        background: ${C.bg}; border-radius: 8px;
        max-width: 460px; width: 100%;
        padding: 36px 32px 32px;
        position: relative; text-align: center;
        box-shadow: 0 24px 80px rgba(0,0,0,0.25);
        transform: translateY(20px) scale(0.96);
        transition: transform 0.35s cubic-bezier(0.34,1.56,0.64,1);
        font-family: 'Cormorant Garamond', Georgia, serif;
      }
      #hofa-pp-overlay.is-open #hofa-pp-box { transform: translateY(0) scale(1); }
      #hofa-pp-box::before {
        content: ''; position: absolute; top: 0; left: 0; right: 0;
        height: 3px; background: ${C.gold}; border-radius: 8px 8px 0 0;
      }
      #hofa-pp-close {
        position: absolute; top: 12px; right: 14px;
        background: none; border: none; font-size: 20px; line-height: 1;
        color: ${C.gold}; cursor: pointer; padding: 4px 8px;
        border-radius: 4px; transition: color 0.2s;
      }
      #hofa-pp-close:hover { color: ${C.dark}; }

      .hofa-pp-paw   { display: block; margin: 0 auto 12px; }
      .hofa-pp-tag   {
        display: inline-flex; align-items: center; gap: 6px;
        background: rgba(184,147,74,0.12); border: 1px solid rgba(184,147,74,0.35);
        color: ${C.gold}; font-size: 10px; font-weight: 700;
        letter-spacing: 0.2em; text-transform: uppercase;
        padding: 4px 12px; border-radius: 20px; margin-bottom: 12px;
        font-family: 'Cormorant Garamond', Georgia, serif;
      }
      .hofa-pp-title {
        font-family: 'Playfair Display', Georgia, serif;
        font-size: clamp(18px,4vw,24px); font-weight: 900;
        color: ${C.dark}; line-height: 1.15; margin: 0 0 6px;
      }
      .hofa-pp-sub {
        font-family: 'Playfair Display', Georgia, serif;
        font-style: italic; font-size: 14px;
        color: ${C.pink}; margin: 0 0 20px;
      }
      .hofa-pp-product {
        background: ${C.card}; border-radius: 6px;
        padding: 12px 14px; display: flex; align-items: center; gap: 12px;
        text-align: left; margin-bottom: 20px; border: 1px solid ${C.border};
      }
      .hofa-pp-img {
        width: 54px; height: 54px; border-radius: 4px;
        object-fit: cover; flex-shrink: 0; background: ${C.border};
      }
      .hofa-pp-info { flex: 1; min-width: 0; }
      .hofa-pp-name {
        font-family: 'Playfair Display', Georgia, serif;
        font-size: 13.5px; font-weight: 700; color: ${C.dark};
        line-height: 1.3; display: block;
        white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
      }
      .hofa-pp-price {
        font-size: 13px; font-weight: 600; color: ${C.gold};
        display: block; margin-top: 2px;
        font-family: 'Cormorant Garamond', Georgia, serif;
      }
      .hofa-pp-check {
        width: 26px; height: 26px; background: #eaf6ee;
        border-radius: 50%; display: flex; align-items: center;
        justify-content: center; flex-shrink: 0;
      }
      .hofa-pp-or {
        display: flex; align-items: center; gap: 10px;
        font-size: 11px; letter-spacing: 0.14em; text-transform: uppercase;
        color: ${C.gold}; margin-bottom: 10px;
        font-family: 'Cormorant Garamond', Georgia, serif;
      }
      .hofa-pp-or::before, .hofa-pp-or::after {
        content: ''; flex: 1; height: 1px; background: rgba(184,147,74,0.3);
      }
      .hofa-pp-btns { display: flex; flex-direction: column; gap: 10px; }
      .hofa-pp-btn {
        display: flex; align-items: center; justify-content: center; gap: 8px;
        border-radius: 4px; padding: 14px 20px;
        font-family: 'Cormorant Garamond', Georgia, serif;
        font-size: 13px; font-weight: 700; letter-spacing: 0.18em;
        text-transform: uppercase; cursor: pointer;
        text-decoration: none; transition: all 0.22s;
        border: none; width: 100%; box-sizing: border-box;
      }
      .hofa-pp-btn--dark    { background: ${C.dark}; color: ${C.bg}; }
      .hofa-pp-btn--dark:hover { background: ${C.gold}; color: #fff; }
      .hofa-pp-btn--outline { background: transparent; color: ${C.dark}; border: 1.5px solid ${C.dark}; }
      .hofa-pp-btn--outline:hover { background: ${C.dark}; color: ${C.bg}; }

      /* Cart page — Continue Shopping button */
      .hofa-continue-wrap { text-align: center; margin-top: 14px; }
      .hofa-continue-link {
        display: inline-flex; align-items: center; gap: 8px;
        background: transparent; color: ${C.dark};
        border: 1.5px solid ${C.border}; border-radius: 4px;
        padding: 13px 24px; font-family: 'Cormorant Garamond', Georgia, serif;
        font-size: 13px; font-weight: 700; letter-spacing: 0.18em;
        text-transform: uppercase; text-decoration: none;
        transition: all 0.22s; width: 100%; justify-content: center;
        box-sizing: border-box;
      }
      .hofa-continue-link:hover { background: ${C.dark}; color: ${C.bg}; border-color: ${C.dark}; }

      @media (max-width: 480px) {
        #hofa-pp-box { padding: 28px 16px 22px; }
        .hofa-pp-title { font-size: 18px; }
      }
    `;
    document.head.appendChild(s);
  }

  /* ── Build popup DOM ── */
  function buildPopup() {
    if (document.getElementById('hofa-pp-overlay')) return;
    var el = document.createElement('div');
    el.id = 'hofa-pp-overlay';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.innerHTML =
      '<div id="hofa-pp-box">' +
        '<button id="hofa-pp-close" aria-label="Close">&#x2715;</button>' +
        '<svg class="hofa-pp-paw" width="34" height="34" viewBox="0 0 34 34" fill="' + C.gold + '">' +
          '<ellipse cx="17" cy="22" rx="9.5" ry="7.5"/>' +
          '<ellipse cx="6.5"  cy="12.5" rx="3.8" ry="5"/>' +
          '<ellipse cx="27.5" cy="12.5" rx="3.8" ry="5"/>' +
          '<ellipse cx="11.5" cy="7.5"  rx="3"   ry="3.8"/>' +
          '<ellipse cx="22.5" cy="7.5"  rx="3"   ry="3.8"/>' +
        '</svg>' +
        '<div class="hofa-pp-tag">' +
          '<svg width="12" height="12" viewBox="0 0 12 12" fill="none">' +
            '<circle cx="6" cy="6" r="5.5" stroke="' + C.gold + '" stroke-width="1"/>' +
            '<path d="M3.5 6l2 2 3.5-3.5" stroke="' + C.gold + '" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
          'Added to Basket' +
        '</div>' +
        '<h2 class="hofa-pp-title">Nice choice.</h2>' +
        '<p  class="hofa-pp-sub">Standards are being maintained.</p>' +
        '<div class="hofa-pp-product" id="hofa-pp-product">' +
          '<img class="hofa-pp-img" id="hofa-pp-img" src="" alt="">' +
          '<div class="hofa-pp-info">' +
            '<span class="hofa-pp-name"  id="hofa-pp-name"></span>' +
            '<span class="hofa-pp-price" id="hofa-pp-price"></span>' +
          '</div>' +
          '<div class="hofa-pp-check">' +
            '<svg width="14" height="14" viewBox="0 0 14 14" fill="none">' +
              '<path d="M3 7l3 3 5-5" stroke="#2e7d4f" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</div>' +
        '</div>' +
        '<div class="hofa-pp-btns">' +
          '<div class="hofa-pp-or">or</div>' +
          '<a href="/collections/all" class="hofa-pp-btn hofa-pp-btn--dark">' +
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none">' +
              '<path d="M1 8h14M9 3l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
            'Continue Shopping' +
          '</a>' +
          '<a href="/cart" class="hofa-pp-btn hofa-pp-btn--outline">View Basket</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
    el.addEventListener('click', function (e) { if (e.target === el) closePopup(); });
    document.getElementById('hofa-pp-close').addEventListener('click', closePopup);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePopup(); });
  }

  function openPopup(opts) {
    opts = opts || {};
    var nameEl  = document.getElementById('hofa-pp-name');
    var priceEl = document.getElementById('hofa-pp-price');
    var imgEl   = document.getElementById('hofa-pp-img');
    if (nameEl)  nameEl.textContent  = opts.name  || '';
    if (priceEl) priceEl.textContent = opts.price || '';
    if (imgEl) { imgEl.src = opts.img || ''; imgEl.alt = opts.name || ''; }
    var overlay = document.getElementById('hofa-pp-overlay');
    if (overlay) { overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    setTimeout(function () { var c = document.getElementById('hofa-pp-close'); if (c) c.focus(); }, 100);
  }

  function closePopup() {
    var o = document.getElementById('hofa-pp-overlay');
    if (o) o.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ── Listen for cart:updated from product page ATC ── */
  document.addEventListener('cart:updated', function () {
    var titleEl = document.querySelector('.hp-title, h1.product__title, h1[itemprop="name"], h1');
    var imgEl   = document.querySelector('.hp-slide--on .hp-slide__img, .product__media img');
    var priceEl = document.querySelector('.hp-price, .hp-price-wrap .hp-price');
    openPopup({
      name:  titleEl ? titleEl.textContent.trim() : '',
      img:   imgEl   ? imgEl.src : '',
      price: priceEl ? priceEl.textContent.trim().split('\n')[0].trim() : ''
    });
  });

  /* ── Init ── */
  injectCSS();
  buildPopup();

})();